var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('VueGoodTable',{attrs:{"columns":_vm.columns,"rows":_vm.rows,"pagination-options":{
            enabled: true,
            mode: 'pages',
            perPageDropdown: [5,25],
            dropdownAllowAll: false,
        }}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }